import React from 'react';
import { Box, TextField, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { colors, fonts, borderRadius, spacing } from '../../constants';

/**
 * ProjectSearchBar Component
 * Search bar component with clear button
 */
const ProjectSearchBar = ({ searchQuery, onSearchChange, onClearSearch }) => {
  return (
    <Box sx={{ mb: spacing.md }}>
      <TextField
        fullWidth
        placeholder="Search projects by name..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: borderRadius.sm,
            backgroundColor: colors.backgroundWhite,
            fontSize: '15px',
            '& fieldset': {
              borderColor: colors.borderDefault,
            },
            '&:hover fieldset': {
              borderColor: colors.primary,
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.primary,
              borderWidth: '2px',
            },
          },
          '& .MuiInputBase-input': {
            padding: '12px 14px',
            fontSize: '15px',
            '&::placeholder': {
              color: colors.textSecondary,
              opacity: 1,
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: colors.textSecondary, fontSize: '20px' }} />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={onClearSearch}
                sx={{
                  color: colors.textSecondary,
                  '&:hover': {
                    backgroundColor: colors.backgroundSoft,
                  },
                }}
              >
                <ClearIcon sx={{ fontSize: '18px' }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default ProjectSearchBar;
